module.exports = __webpack_public_path__ + "static/media/default_prd.a129ae49.png";